import { CloseOutlined, LoadingOutlined } from "@ant-design/icons";
import { SubscriptionUser } from "@coeff/api";
import React from "react";

import {
  GhostBtn,
  ModalCard,
  ModalHeader,
  Overlay,
  PrimaryBtn,
  WarnBox,
} from "../../pagesV2/Members.styles";

type Props = {
  /** null = closed. */
  user: SubscriptionUser | null;
  busy: boolean;
  onConfirm: () => void | Promise<void>;
  onClose: () => void;
  /** Pass true when the subscription carries the AI Dashboards add-on. */
  hasWebDashboardAddon?: boolean;
};

/** Confirms removing a member's seat (they drop to the Free plan). */
export const DowngradeToFreeModal: React.FC<Props> = ({
  user,
  busy,
  onConfirm,
  onClose,
  hasWebDashboardAddon,
}) => {
  if (!user) {
    return null;
  }
  const first = user.first_name || user.email;
  return (
    <Overlay onClick={onClose}>
      <ModalCard onClick={e => e.stopPropagation()}>
        <ModalHeader>
          <div className="title">Downgrade to Free!</div>
          <button className="close" onClick={onClose}>
            <CloseOutlined />
          </button>
        </ModalHeader>
        <div style={{ marginTop: 16, fontSize: 14 }}>
          <b>
            {first} {user.last_name || ""}
          </b>{" "}
          will be removed from your plan and downgraded to the Free plan.
        </div>
        <WarnBox>
          Scheduled imports and exports to data sources will no longer work, and other users won't
          be able to refresh {first}'s imports.
          {hasWebDashboardAddon && (
            <div style={{ marginTop: 8 }}>
              Their AI Dashboards will stop refreshing and be archived.
            </div>
          )}
        </WarnBox>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <GhostBtn onClick={onClose}>Cancel</GhostBtn>
          <PrimaryBtn disabled={busy} onClick={onConfirm}>
            {busy && <LoadingOutlined spin />}
            Yes, Downgrade to Free
          </PrimaryBtn>
        </div>
      </ModalCard>
    </Overlay>
  );
};
